<template>
	<div class="export-page">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Admin Export Page</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="page-content mt-4">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-3">
							<div class="input-group">
								<input
								type="text"
								class="form-control"
								placeholder="Cari Nama File"
								v-model="keyword"
								@input="onKeywordChange"
								v-focus>
							</div>
						</div>
						<div class="col-sm-9">
						</div>
					</div>
				</div>
				<div class="user-wallet-list table-responsive">
					<table class="user-wallet-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="5%" class="text-center">
									No
								</th>
								<th width="25%" class="th-sort text-left" :class="sortClass('file_name')"
									@click="changeSorting('file_name')">
									File Name
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('type')"
									@click="changeSorting('type')">
									Type
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('status')"
									@click="changeSorting('status')">
									Status
								</th>
								<th width="10%" class="th-sort text-center" :class="sortClass('requested_at')"
								@click="changeSorting('requested_at')">
									Requested At
								</th>
								<th width="10%" class="th-sort text-center" :class="sortClass('completed_at')"
								@click="changeSorting('completed_at')">
									Completed At
								</th>
								<th width="5%" class="text-left">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" :key="index">
								<td class="text-center">
									{{ index+1 }}
								</td>
								<td>
									<div class="name">
										{{ item.file_name }}
									</div>
								</td>
								<td>
									<div class="name">
										{{ showType(item.type) }}
									</div>
								</td>
								<td>
									<div
										class="btn-status"
										:class="{
										'status-completed': item.status === 'completed' && !isExpired(item.completed_at),
										'status-failed': item.status === 'failed',
										'status-expired': item.status === 'completed' && isExpired(item.completed_at),
										'status-processing': item.status === 'processing'
										}"
									>
									<span class="text-center">
										{{ isExpired(item.completed_at) && item.status === 'completed' ? 'Expired' : toTitleCase(item.status) }}
									</span>
									</div>
									</td>
								<td class="">
									<div class="date-width text-center">
										{{ item.requested_at ? formatDate(moment,item.requested_at, 'DD-MM-YYYY HH:mm') : '-' }}
									</div>
								</td>
								<td class="">
									<div class="date-width text-center">
										{{ item.completed_at ? formatDate(moment,item.completed_at, 'DD-MM-YYYY HH:mm') : '-' }}
									</div>
								</td>
								<td class="">
									<button
										class="btn flex-center btn-outline-primary"
										@click="download(item)"
										:disabled="item.status === 'processing' || item.status === 'expired' || item.status === 'failed' || (isExpired(item.completed_at) && item.status === 'completed')"
									>
									{{ item.status === 'processing' ? 'Exporting' : 'Download' }}
										<span v-if="item.status === 'processing'" class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Export Data Found yet.</span>
						<span v-else>No Export was found</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	formatDate,
	downloadFile,
	toTitleCase,
} from '@/lib/helper';
import adminApi from '@/api/admin';

export default {
	name: 'AdminExportPage',
	data() {
		return {
			limit: 25,
			page: 1,
			sort_by: 'requested_at',
			sort: 'desc',
			isFetching: false,
			items: [],
			isAll: false,
			keyword: null,
			isDownloading: false,
		};
	},
	sockets: {
		export_update(data) {
			const selectedExport = this.items.find(item => item?._id === data?.export_id);
			selectedExport.status = data.status;
			selectedExport.completed_at = data.completed_at;
			selectedExport.file_url = data.file_url;
		},
	},
	methods: {
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		toTitleCase,
		isExpired(completedAt) {
			let isExpired = false;
			if (completedAt !== null) {
				const completedTime = this.moment(completedAt);
				const currentTime = this.moment(); // Current time
				const oneDayAfterCompletion = this.moment(completedTime).add(1, 'days');

				isExpired = completedTime.isBefore(currentTime) && currentTime.isAfter(oneDayAfterCompletion);
			}

			return isExpired;
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.keyword) {
				params.keyword = this.keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				this.isSearchingSupplier = false;
				const items = response.data;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			adminApi.getListExportPage(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		download(item) {
			this.isDownloading = true;

			downloadFile(item.file_url);

			this.isDownloading = false;
		},
		onKeywordChange() {
			this.ooDelay(() => {
				this.fetchItems();
			}, 1000);
		},
		showType(type) {
			return this.toTitleCase(type.replace('_', ' '));
		},
	},
	created() {
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
	// Variables
	$border-radius: 8px;

	// Mixin for status styles
	@mixin status-style($text-color, $border-color, $background-color) {
		color: $text-color;
		padding: 6px;
		margin: 2px;
		text-align: center;
		border-radius: $border-radius;
		border-color: $border-color;
		background-color: $background-color;
	}

	// Button Styles
	.btn-status {
		width: 100px;
	}

	// Date Width
	.date-width {
		min-width: 115px;
	}

	// Status Styles
	.status-completed {
		@include status-style(white, #80b636, #8dc63f);
	}

	.status-failed {
		@include status-style(white, #ed1c24, #ed1c24);
	}

	.status-expired {
		@include status-style(white, #ffc107, #ffc107);
	}

	.status-processing {
		@include status-style(white, #606060, #606060);
	}
</style>
